(() => {
  window.addEventListener("load", () => {
    const body = document.getElementsByTagName("body")[0];
    const siteNavigation = document.querySelector("#sp-navigation");
    if (!siteNavigation) {
      return;
    }
    const toggleButton = siteNavigation.querySelector(".js-menuToggle");
    if ("undefined" === typeof toggleButton) {
      return;
    }
    const menuLinks = siteNavigation.querySelectorAll(".menu > .menu-item > a");
    menuLinks.forEach((menuLink) => {
      menuLink.addEventListener("click", () => {
        toggleButton.setAttribute("aria-expanded", "false");
        body.dataset.navState = "close";
      });
    });

    // ボタンクリックでSPナビ .toggled, aria-expanded 切替
    toggleButton.addEventListener("click", () => {
      siteNavigation.classList.toggle("toggled");

      if (toggleButton.getAttribute("aria-expanded") === "true") {
        toggleButton.setAttribute("aria-expanded", "false");
        body.dataset.navState = "close";
      } else {
        toggleButton.setAttribute("aria-expanded", "true");
        body.dataset.navState = "open";
      }
    });
  });
})();
